import Core from "@/modules/core/service/Core";
import { getApiIotBaseUrl } from "@/config";

const url = {
    state : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/{0}`,
    events: () => `${getApiIotBaseUrl()}/api/iot-v2/sites/{0}/events?from={1}&to={2}`,
};

export default {
    // Replaces the deprecated /api/iot/unit/{deviceId}/movements - the new iot-api-svc only
    // exposes a flat, unfiltered event stream per site (door/ride/escalator/connectivity events
    // mixed together), so a "ride" is now identified by type === "RIDE" and filtered client-side.
    //
    // Uses Core.method.get2 rather than get() - this backs decorative, non-critical UI (a status
    // dot, a "recent movements" tooltip) that polls every few minutes in the background. get()'s
    // shared error handling would pop a global error toast on any hiccup and - worse - log the
    // user out entirely on a transient 401, for a feature nobody asked to see right now. get2()
    // never rejects and never touches global error/auth handling, so a failure here just means
    // the status/movements silently stay unavailable instead of disrupting the rest of the app.
    lastMovements (siteId, hours) {
        const to = new Date();
        const from = new Date(to.getTime() - hours * 60 * 60 * 1000);

        return Core.method.get2(url.events(), siteId, encodeURIComponent(from.toISOString()), encodeURIComponent(to.toISOString()))
            .then(result => {
                if (!result.ok) {
                    return [];
                }

                return result.data
                    .filter(event => event.type === "RIDE")
                    .sort((l, r) => new Date(r.triggeredAt) - new Date(l.triggeredAt));
            });
    },

    status (siteId) {
        return Core.method.get2(url.state(), siteId).then(result => result.ok ? result.data : null);
    },
}
